import { render, staticRenderFns } from "./CreateDisbursement.vue?vue&type=template&id=4ef81c5a"
import script from "./CreateDisbursement.vue?vue&type=script&lang=js"
export * from "./CreateDisbursement.vue?vue&type=script&lang=js"
import style0 from "./CreateDisbursement.vue?vue&type=style&index=0&id=4ef81c5a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports